import { useLocation } from 'react-router-dom'
import { EmptyState } from '@/components/platform/primitives'
import { navItemForPath } from '@/components/platform/nav'

export function PlaceholderPage() {
  const { pathname } = useLocation()
  const item = navItemForPath(pathname)
  const label = item?.label || 'Pantalla'

  return (
    <>
      <div className="page-header">
        <div className="page-title-block">
          <div className="eyebrow">{item?.section || ''}</div>
          <h1>{label}</h1>
          <div className="subtitle">Pantalla planificada — sigue el mismo patrón de tabla + filtros + drawer del resto del panel.</div>
        </div>
      </div>
      <div className="card">
        <div className="card-body" style={{ padding: 0 }}>
          <EmptyState
            icon={item?.icon || 'inbox'}
            title={`${label} — en migración`}
            desc="Esta pantalla todavía no fue portada del prototipo a la app real. El sistema de componentes ya está listo; volvé al Dashboard o entrá a Tenants para ver pantallas terminadas."
          />
        </div>
      </div>
    </>
  )
}
